import {
  addDays, differenceInDays, getDay, isValid, parse,
} from 'date-fns';
import { isNil } from 'lodash';
import { useEffect } from 'react';

const useDayId = () => {
  const origin = parse('2023-01-01', 'yyyy-MM-dd', new Date());

  const getDayIdFromDate = (date) => {
    if (!date || !isValid(date)) return null;

    return differenceInDays(date, origin) + 1;
  };

  const getDateFromDayId = (dayId) => {
    if (isNil(dayId)) return null;

    return addDays(origin, +dayId - 1);
  };

  const getWeekDayIndexFromDayId = (dayId) => {
    if (!getDateFromDayId(dayId)) return null;
    return getDay(getDateFromDayId(dayId)) + 1;
  };

  useEffect(() => {
    if (process?.env?.NEXT_PUBLIC_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.info(`%c Today's day id : ${getDayIdFromDate(new Date())}`, 'background: #FFF3E1; color: #DD8706');
    }
  }, []);

  return {
    getDayIdFromDate,
    getDateFromDayId,
    getWeekDayIndexFromDayId,
  };
};

export default useDayId;
